<template>
  <section class="stemwijzer bg-blue">
    <FlexWrap>
      <div class="container">
        <figure class="figure">
          <img
            :src="src"
            draggable="false"
            alt=""
            width="80"
            height="263"
            class="character"
          />
        </figure>

        <h2 class="title">Stemwijzer</h2>
        <ul class="vote-items">
          <VoteListItem
            v-for="(item, index) in items"
            :key="index"
            :year="item.year"
            :vote="item.vote"
          >
            {{ item.text }}
          </VoteListItem>
        </ul>
      </div>
    </FlexWrap>
  </section>
</template>

<script>
import { FlexWrap } from '@/components/chapter'
import { chapterMixin } from '@/mixins'
import { EventBus } from '@/EventBus'
import VoteListItem from './VoteListItem'

export default {
  name: 'Stemwijzer',
  data () {
    return {
      filename: 'fy',
      hasEnoughGround: false,
      votingCheck: false,
      isOldEnough: false,
      isDutchAndOldEnough: false,
      items: [{
        year: 1815,
        vote: false,
        text: 'Helaas, je mag niet stemmen. Maar je bent lang niet de enige. In 1815 had geen enkele vrouw stemrecht.'
      }, {
        year: 1850,
        vote: false,
        text: 'Helaas, je mag niet stemmen. Nog altijd had geen enkele vrouw stemrecht.'
      }, {
        year: 1896,
        vote: false,
        text: 'Vrouwen hadden nog steeds geen stemrecht, dus helaas: je mag niet stemmen.'
      }, {
        year: 1919,
        vote: false,
        text: 'Helaas, je bent nog te jong. De kiesgerechtigde leeftijd was nog steeds 25 jaar.'
      }, {
        year: 2019,
        vote: true,
        text: 'Je mag stemmen!'
      }]
    }
  },
  mounted () {
    EventBus
      .$on('characterChoice', filename => {
        this.filename = filename
        this.checkVoteAbility()
      })
      .$on('groundSize', hasEnoughGround => {
        this.hasEnoughGround = hasEnoughGround
        this.checkVoteAbility()
      })
      .$on('votingCheck', votingCheck => {
        this.votingCheck = votingCheck
        this.checkVoteAbility()
      })
      .$on('isOldEnough', isOldEnough => {
        this.isOldEnough = isOldEnough
        this.checkVoteAbility()
      })
      .$on('isDutchAndOldEnough', isDutchAndOldEnough => {
        this.isDutchAndOldEnough = isDutchAndOldEnough
        this.checkVoteAbility()
      })
  },
  methods: {
    check1815 () {
      if (this.filename === 'my') {
        this.items[0].vote = false
        this.items[0].text = 'Helaas, je mag niet stemmen. Daarvoor moest je namelijk minimaal 23 jaar zijn. En rijk bovendien.'
      }

      if (this.filename === 'mo') {
        this.items[0].vote = true
        this.items[0].text = 'Jij maakt kans op stemrecht. Daarvoor moest je namelijk man zijn én minimaal 23 jaar oud. Maar de kans dat je écht mocht stemmen, is heel klein. Je moest ook nog eens behoorlijk wat vermogen hebben.'
      }

      if (['fy', 'fo'].includes(this.filename)) {
        this.items[0].vote = false
        this.items[0].text = 'Helaas, je mag niet stemmen. Maar je bent lang niet de enige. In 1815 had geen enkele vrouw stemrecht.'
      }
    },
    check1850 () {
      if (this.filename === 'my') {
        this.items[1].vote = false
        this.items[1].text = this.hasEnoughGround ? 'Grond of niet, dat maakt voor jou helaas niks uit. Om te mogen stemmen, moest je namelijk nog steeds minimaal 23 jaar zijn.' : 'Helaas, je mag niet stemmen. Naast dat je niet genoeg grond bezit, moest je ook nog steeds ouder dan 23 jaar zijn.'
      }

      if (this.filename === 'mo') {
        this.items[1].vote = this.hasEnoughGround
        this.items[1].text = this.hasEnoughGround ? 'Gefeliciteerd, jij hoort bij de 10 procent van de mannelijke 23+’ers die in 1850 naar de stembus mocht. Over je grond betaalde je namelijk een speciale belasting, en die belasting speelde een belangrijke rol in het nieuwe kiessysteem van 1850.' : 'Helaas, je hebt niet genoeg grond. Daarover betaalde je namelijk belasting, en die belasting speelde een belangrijke rol in het nieuwe kiessysteem van 1850.'
      }

      if (['fy', 'fo'].includes(this.filename)) {
        this.items[1].vote = false
        this.items[1].text = 'Helaas, je mag niet stemmen. Nog altijd had geen enkele vrouw stemrecht.'
      }
    },
    check1896 () {
      if (['fy', 'fo'].includes(this.filename)) {
        this.items[2].vote = false
        this.items[2].text = 'Helaas voldoe je niet aan de voorwaarden om te mogen stemmen.'
      }

      if (this.filename === 'my') {
        this.items[2].vote = false
        this.items[2].text = this.votingCheck ? 'Je bent goed bezig, maar nog te jong! De kiesgerechtigde leeftijd ging in 1896 omhoog naar 25 jaar.' : 'Je voldoet niet aan de voorwaarden, én je bent te jong. De kiesgerechtigde leeftijd ging in 1896 omhoog naar 25 jaar.'
      }

      if (this.filename === 'mo' && !this.votingCheck) {
        this.items[2].vote = false
        this.items[2].text = 'Helaas voldoe je niet aan de voorwaarden om te mogen stemmen.'
      }

      if (this.filename === 'mo' && this.votingCheck) {
        this.items[2].vote = this.isOldEnough
        this.items[2].text = this.isOldEnough ? 'Oké, dan staat echt niks meer jouw tripje naar de stembus in de weg. De kiesgerechtigde leeftijd ging in 1896 omhoog naar 25 jaar.' : 'Jammer, stemmen zit  er voor jou tóch niet in. De kiesgerechtigde leeftijd ging in 1896 namelijk omhoog naar 25 jaar.'
      }
    },
    check1919 () {
      if (['fy', 'my'].includes(this.filename)) {
        this.items[3].vote = false
        this.items[3].text = this.isDutchAndOldEnough ? 'Helaas, je bent nog te jong. De kiesgerechtigde leeftijd was nog steeds 25 jaar.' : 'Helaas, zonder de Nederlandse nationaliteit ben je niet kiesgerechtigd.'
      }

      if (['fo', 'mo'].includes(this.filename)) {
        this.items[3].vote = this.isDutchAndOldEnough
        this.items[3].text = this.isDutchAndOldEnough ? 'Je mag stemmen!' : 'Helaas, je bent nog te jong of je hebt geen Nederlandse nationaliteit. De kiesgerechtigde leeftijd was nog steeds 25 jaar en zonder de Nederlandse nationaliteit ben je niet kiesgerechtigd.'
      }
    },
    checkVoteAbility () {
      this.check1815()
      this.check1850()
      this.check1896()
      this.check1919()
    }
  },
  mixins: [chapterMixin],
  components: {
    FlexWrap,
    VoteListItem
  },
  computed: {
    src () {
      return require(`@/assets/images/char-${this.filename}.svg`)
    }
  }
}
</script>

<style lang="scss" scoped>
.figure {
  text-align: center;
  position: relative;

  &::before {
    content: '';
    width: 196px;
    height: 196px;
    background-color: $c-light;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    margin: 0 auto;
    transform: translateY(-50%);
  }
}

.character {
  position: relative;
  z-index: 2;
}

.title {
  font-size: 24px;
  font-weight: $fw-bold;
  color: white;
  margin: 1em auto;
  text-align: center;
}
</style>
